import React, { FunctionComponent, memo } from 'react'
import { User } from '../../../../responses/users'
import styles from './ProjectList.module.sass'
import UserPanel from '../../../data-components/elements/UserElement/UserElement'
import { UserListIcon } from '../ProjectPage/UsersList/UsersList'
import { useMeasure } from 'react-use'

const UsersSidePanel: FunctionComponent<{ users: User[], onClick?: () => void }> = props => {
    const [setRef, { width }] = useMeasure()

    return <div ref={ref => ref && setRef(ref)} className={styles.users}>
        {
            props.users.map(user => <UserPanel key={user.id} onlyIcon noCharge user={user}/>)
        }
        <div className={styles.openButton} style={{ display: (width < props.users.length * 36) ? 'block' : 'none' }}>
            <UserListIcon className={styles.icon} onClick={props.onClick}>
                +{Math.floor((props.users.length * 36 + 74 - width) / 36)}
            </UserListIcon>
        </div>
    </div>
}

export default memo(UsersSidePanel)